import { Edit } from 'lucide-react'
import React from 'react'

export default function SettingsTable({ settingsList, onEdit }) {

    return (
        <div className="overflow-x-auto">
            <table className="w-full text-sm text-left text-gray-500">
                <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                    <tr>
                        <th scope="col" className="px-6 py-3">Name</th>
                        <th scope="col" className="px-6 py-3">Value</th>
                        {/* <th scope="col" className="px-6 py-3">Actions</th> */}
                    </tr>
                </thead>
                <tbody>
                    {(settingsList ?? []).map(sett => (
                        <tr key={sett.key} className="bg-white border-b hover:bg-gray-50">
                            <td className="px-6 py-4 font-mono text-gray-700">{sett?.key}</td>
                            <td className="px-6 py-4 font-medium text-gray-900">{sett?.value}</td>
                            <td className="px-6 py-4 font-medium text-gray-900"> 
                                <button onClick={() => onEdit(sett)} title="Edit User" className="p-2 text-gray-500 hover:bg-gray-200 rounded-full transition-colors">
                                    <Edit size={18} />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {settingsList.length === 0 && (
                <div className="text-center py-12 text-gray-500">
                    <p>No Configuration found.</p>
                </div>
            )}
        </div>
    )
}
